import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-723799db"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-white rounded-xl border border-primary-200 shadow-soft overflow-hidden"
}
const _hoisted_2 = { class: "p-4 border-b border-primary-100 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5 text-accent-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-heading font-semibold text-primary-800" }, " Getting Started ", -1))
const _hoisted_6 = { class: "text-xs text-primary-500" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "h-1 bg-primary-100" }
const _hoisted_10 = { class: "p-4 space-y-2" }
const _hoisted_11 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 13l4 4L19 7"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "flex-1 min-w-0" }
const _hoisted_15 = {
  key: 0,
  class: "w-4 h-4 text-primary-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 5l7 7-7 7"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "p-4 bg-green-50 border-t border-green-100 text-center"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-700 font-medium" }, " You're all set! Welcome to the community. ", -1))
const _hoisted_20 = [
  _hoisted_19
]

import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { HoodApi } from "@/services/HoodApi";

interface Task {
  id: string;
  title: string;
  description: string;
  route: string;
  completed: boolean;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const STORAGE_KEY = "foxwood_onboarding";

const route = useRoute();
const auth = useAuthStore();

const isDismissed = computed(() => auth.onboarding_dismissed);

const tasks = ref<Task[]>([
  {
    id: "profile",
    title: "Complete your profile",
    description: "Add your contact preferences",
    route: "/profile",
    completed: false,
  },
  {
    id: "proposals",
    title: "Browse community proposals",
    description: "See what neighbors are suggesting",
    route: "/proposals",
    completed: false,
  },
  {
    id: "events",
    title: "Check upcoming events",
    description: "Don't miss neighborhood gatherings",
    route: "/events",
    completed: false,
  },
  {
    id: "posts",
    title: "Visit the community board",
    description: "Connect with your neighbors",
    route: "/posts",
    completed: false,
  },
  {
    id: "gallery",
    title: "Explore the photo gallery",
    description: "See neighborhood memories",
    route: "/gallery",
    completed: false,
  },
]);

const completedCount = computed(
  () => tasks.value.filter((t) => t.completed).length
);
const progressPercent = computed(
  () => (completedCount.value / tasks.value.length) * 100
);
const allComplete = computed(() => completedCount.value === tasks.value.length);

// Load saved task completion state (tasks are still tracked in localStorage)
onMounted(() => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      const data = JSON.parse(saved);
      // Only load completed tasks from localStorage, dismissed state comes from auth store
      if (data.completed) {
        tasks.value.forEach((task) => {
          if (data.completed.includes(task.id)) {
            task.completed = true;
          }
        });
      }
    } catch {
      // Invalid data, start fresh
    }
  }
});

// Watch route changes to auto-complete tasks
watch(
  () => route.path,
  (path) => {
    const task = tasks.value.find((t) => t.route === path);
    if (task && !task.completed) {
      task.completed = true;
      saveState();
    }
  },
  { immediate: true }
);

const markComplete = (taskId: string) => {
  const task = tasks.value.find((t) => t.id === taskId);
  if (task) {
    task.completed = true;
    saveState();
  }
};

const dismiss = async () => {
  try {
    await HoodApi.update_user_details({ onboarding_dismissed: true });
    auth.onboarding_dismissed = true;
  } catch (e) {
    console.error("Failed to dismiss onboarding:", e);
    // Still dismiss locally even if API fails
    auth.onboarding_dismissed = true;
  }
  saveState();
};

const saveState = () => {
  // Only save task completion to localStorage, dismissed state is in the API
  const data = {
    completed: tasks.value.filter((t) => t.completed).map((t) => t.id),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

// Expose reset method for profile page toggle
expose({
  reset: async () => {
    localStorage.removeItem(STORAGE_KEY);
    tasks.value.forEach((t) => (t.completed = false));
    try {
      await HoodApi.update_user_details({ onboarding_dismissed: false });
      auth.onboarding_dismissed = false;
    } catch (e) {
      console.error("Failed to reset onboarding:", e);
      auth.onboarding_dismissed = false;
    }
  },
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_unref(isDismissed) && !_unref(allComplete))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(completedCount)) + " of " + _toDisplayString(tasks.value.length) + " complete ", 1)
            ])
          ]),
          _createElementVNode("button", {
            onClick: dismiss,
            class: "text-primary-400 hover:text-primary-600 transition-colors",
            title: "Dismiss"
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "h-full bg-accent-500 transition-all duration-500",
            style: _normalizeStyle({ width: _unref(progressPercent) + '%' })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: task.id,
              to: task.route,
              class: _normalizeClass(["flex items-center gap-3 p-3 rounded-lg transition-all duration-200", 
          task.completed
            ? 'bg-green-50 cursor-default'
            : 'bg-primary-50 hover:bg-primary-100 cursor-pointer'
        ]),
              onClick: ($event: any) => (markComplete(task.id))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors", 
            task.completed
              ? 'bg-green-500 text-white'
              : 'border-2 border-primary-300'
          ])
                }, [
                  (task.completed)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-sm font-medium", task.completed ? 'text-green-700' : 'text-primary-700'])
                  }, _toDisplayString(task.title), 3),
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-xs truncate", task.completed ? 'text-green-500' : 'text-primary-400'])
                  }, _toDisplayString(task.description), 3)
                ]),
                (!task.completed)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class", "onClick"]))
          }), 128))
        ]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_unref(allComplete))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})